// Catálogo maestro de servicios usado por el carrusel de la home y por la
// cuadrícula fija de /servicios. Cambiar aquí actualiza ambos.

export const SERVICES = [
  {
    slug: "xega-vip",
    slot: "home.carousel.xega_vip",
    title_es: "XEGA VIP", title_en: "XEGA VIP", title_pt: "XEGA VIP",
    desc_es: "Localización de personas en situación de emergencia",
    desc_en: "Locating people in emergency situations",
    desc_pt: "Localização de pessoas em situação de emergência",
    img: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=70&w=900&auto=format&fit=crop",
  },
  {
    slug: "merch-finder",
    slot: "home.carousel.merch_finder",
    title_es: "MERCH FINDER", title_en: "MERCH FINDER", title_pt: "MERCH FINDER",
    desc_es: "Localización de mercancía",
    desc_en: "Merchandise tracking",
    desc_pt: "Localização de mercadoria",
    img: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?q=70&w=900&auto=format&fit=crop",
  },
  {
    slug: "e-tracker",
    slot: "home.carousel.e_tracker",
    title_es: "E-TRACKER", title_en: "E-TRACKER", title_pt: "E-TRACKER",
    desc_es: "Localización de vehículos y flotillas",
    desc_en: "Vehicle and fleet tracking",
    desc_pt: "Localização de veículos e frotas",
    img: "https://images.unsplash.com/photo-1518770660439-4636190af475?q=70&w=900&auto=format&fit=crop",
  },
  {
    slug: "sentinel",
    slot: "home.carousel.sentinel",
    title_es: "SENTINEL", title_en: "SENTINEL", title_pt: "SENTINEL",
    desc_es: "Localización de pre-liberados",
    desc_en: "Pre-release monitoring",
    desc_pt: "Localização de pré-libertados",
    img: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=70&w=900&auto=format&fit=crop",
  },
  {
    slug: "escoltas",
    slot: "home.carousel.escoltas",
    title_es: "ESCOLTAS", title_en: "EXECUTIVE ESCORT", title_pt: "ESCOLTAS",
    desc_es: "Protección ejecutiva 360° con reacción inmediata",
    desc_en: "360° executive protection with immediate response",
    desc_pt: "Proteção executiva 360° com reação imediata",
    img: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=70&w=900&auto=format&fit=crop",
  },
  {
    slug: "seguridad-privada",
    slot: "home.carousel.seguridad_privada",
    title_es: "SEGURIDAD PRIVADA", title_en: "PRIVATE SECURITY", title_pt: "SEGURANÇA PRIVADA",
    desc_es: "Guardias intramuros · CCTV · Vigilancia",
    desc_en: "On-site guards · CCTV · Surveillance",
    desc_pt: "Guardas internos · CCTV · Vigilância",
    img: "/services/seguridad-privada.jpg",
  },
  {
    slug: "adultos-mayores",
    slot: "home.carousel.adultos_mayores",
    title_es: "ADULTOS MAYORES", title_en: "SENIORS LOCATION", title_pt: "IDOSOS",
    desc_es: "Localización y monitoreo de personas vulnerables",
    desc_en: "Location and monitoring of vulnerable people",
    desc_pt: "Localização e monitoramento de pessoas vulneráveis",
    img: "https://images.unsplash.com/photo-1584515933487-779824d29309?q=70&w=900&auto=format&fit=crop",
  },
];
